/* eslint-disable */

/** unique or primary key constraints on table "argo.work_instruction_instance_history" */
export enum ArgoWorkInstructionInstanceHistoryConstraint {
  /** unique or primary key constraint on columns "work_instruction_instance_history_id" */
  WorkInstructionInstanceHistoryPkey = 'work_instruction_instance_history_pkey'
}

/** select columns of table "argo.work_instruction_instance_history" */
export enum ArgoWorkInstructionInstanceHistorySelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Status = 'status',
  /** column name */
  WorkInstructionInstanceId = 'work_instruction_instance_id'
}

/** update columns of table "argo.work_instruction_instance_history" */
export enum ArgoWorkInstructionInstanceHistoryUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Status = 'status',
  /** column name */
  WorkInstructionInstanceId = 'work_instruction_instance_id'
}

